import { render, staticRenderFns } from "./layout-tabs.vue?vue&type=template&id=678127bc&"
import script from "./layout-tabs.vue?vue&type=script&lang=js&"
export * from "./layout-tabs.vue?vue&type=script&lang=js&"
import style0 from "./layout-tabs.vue?vue&type=style&index=0&id=678127bc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports